import { Injectable } from '@angular/core';
import { DialogHelper } from 'nglhelper';

@Injectable()
export class FormHelper {

    constructor(private dialog: DialogHelper) {

    }

    DisplayLoadDataError(err) {
        var msg = err;
        if (err instanceof Error) {
            msg = err.message;
        }
        var message = "An error has occur while loading form data. Error:" + msg;
        this.dialog.AlertError(message, "Form Error")
            .subscribe((res) => {
                window.location.reload();
            });
    }
}